import { Component, CSSProperties, MouseEvent, ReactNode } from 'react'

import Icon from '../Icons'
import { FilterItemProps, FilterItemVariant } from './types'

export class FliterItem extends Component<FilterItemProps> {
  constructor(props: FilterItemProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e: MouseEvent<HTMLDivElement | HTMLSpanElement>) {
    e.preventDefault()
    const { item, onSelect } = this.props
    if (onSelect) onSelect(item)
  }

  renderControl(controls?: boolean, variant?: FilterItemVariant): ReactNode {
    if (controls) {
      switch (variant) {
        case 'list':
          return <Icon className="ctp-sidebar-item__control--selection" icon="cross" />
        default:
          return null
      }
    }
    return null
  }

  renderAvatar(avatar?: string): ReactNode {
    if (!avatar) return null

    if (avatar === 'tagIcon') {
      return <Icon className="ctp-sidebar-item__avatar-icon" icon={avatar} viewBox="0 0 16 16" />
    }

    if (avatar.lastIndexOf('http', 0) === 0) {
      return <img className="ctp-sidebar-item__avatar-icon" src={avatar} />
    }

    return <Icon className="ctp-sidebar-item__avatar-icon" icon={avatar} />
  }

  renderText(text = '') {
    const normalizedText = text
      ?.replace(/\r?\n|\r/g, ' ') // Replace line breaks with spaces
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim()
    return normalizedText.length > 30 ? normalizedText.slice(0, 30) + '...' : normalizedText
  }

  render() {
    const { controls, isFilter, isSelected, item, variant } = this.props
    const isDropdown = variant === 'dropdown'

    const className = `ctp-sidebar-item ${
      isDropdown
        ? isSelected
          ? 'ctp-sidebar-item-dropdown ctp-sidebar-item-dropdown--selected'
          : 'ctp-sidebar-item-dropdown'
        : isSelected
          ? 'ctp-sidebar-item-selection ctp-sidebar-item-selection--selected'
          : 'ctp-sidebar-item-selection'
    }`

    const avatarClass = `ctp-sidebar-item__avatar ${
      isFilter ? 'ctp-sidebar-item__avatar--filter' : ''
    }`
    const avatarStyle: CSSProperties = {
      backgroundColor: isFilter ? 'lightgray' : item.color ? item.color : 'lightgray',
    }

    return (
      <div
        className={className}
        onClick={variant === 'list' ? (e) => e.preventDefault() : this.handleClick}
      >
        {item.avatar && (
          <div className={avatarClass} style={avatarStyle}>
            {this.renderAvatar(item.avatar)}
          </div>
        )}
        <div className="ctp-sidebar-item__text">{this.renderText(item.text)}</div>
        <div className="ctp-sidebar-item__control" onClick={this.handleClick}>
          {this.renderControl(controls, variant)}
        </div>
      </div>
    )
  }
}

export default FliterItem
